import React, { useCallback, useEffect, useState } from 'react';
import { post } from '../../Auths/AuthToken';
import setUiMessage from '../../../Utilities/Tostify';
import { ucFirst } from '../../../Utilities/Utilities';
import { DEFAULT_DATE_FORMATE } from '../../../constents';
import ComPatSearch from '../../Communication/ComPatSearch';
import Button from '../../Button';
import DatePickerCalander from '../../../Utilities/DatePickerCalander';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';

function AddIntakeFormPopup({ close, handleReload }) {
  const [allData, setAllData] = useState([]);
  const [parentChecked, setParentChecked] = useState({});
  const [checkedIds, setCheckedIds] = useState([]);
  const { user } = useSelector((state) => state.auth);
  const [formData, setFormData] = useState({
    location: '',
    resource: '',
    dob: null,
    dobDatePickerIsOpen: false,
    patientType: 2,
    patients: '',
    lastName: '',
    firstName: '',
    gender: '',
    mobile: '',
    email: '',
    onboard: '0',
  });
  useEffect(() => {
    try {
      (async () => {
        try {
          const response = await post(
            'api/patient/intake/openIntakeFormPopup',
            {
              loginUserId: user?.id,
            },
          );
          if (response.status === 200) {
            setAllData(response?.data);
            setFormData((prev) => ({
              ...prev,
              location: response?.data?.defaultSelectedLocation,
              resource: response?.data?.defaultSelectedResource,
            }));
          }
        } catch (err) {
          setUiMessage('err', err?.message);
        }
      })();
    } catch (error) {
      setUiMessage('err', error?.message);
    }
  }, [user?.id]);

  useEffect(() => {
    // Update the parent checkboxes based on the checked sub-child checkboxes
    const updatedParentChecked = {};
    allData?.intakeFormList &&
      allData?.intakeFormList.forEach((form) => {
        const subCatIds = form.subCat.map((sub) => sub.intakecatId);
        const allChecked = subCatIds.every((id) => checkedIds.includes(id));
        updatedParentChecked[form.formId] = allChecked;
      });
    setParentChecked(updatedParentChecked);
  }, [checkedIds, allData?.intakeFormList]);

  const handleIntakeFormPreview = (uri) => {};

  const handleParentCheckboxChange = (event, formId) => {
    const isChecked = event.target.checked;
    const subCatIds = allData?.intakeFormList
      .find((form) => form.formId === formId)
      .subCat.map((sub) => sub.intakecatId);

    setCheckedIds((prev) =>
      isChecked
        ? [...new Set([...prev, ...subCatIds])]
        : prev.filter((id) => !subCatIds.includes(id)),
    );
  };

  const handleSubChildCheckboxChange = (event, intakecatId) => {
    const isChecked = event.target.checked;
    setCheckedIds((prev) =>
      isChecked
        ? [...new Set([...prev, intakecatId])]
        : prev.filter((id) => id !== intakecatId),
    );
  };

  const handleSaveIntakeForm = async () => {
    try {
      if (formData.location.length === 0) {
        setUiMessage('err', 'Please select location');
        return;
      }

      if (formData.resource.length === 0) {
        setUiMessage('err', 'Please select resource');
        return;
      }

      if (
        Number(formData.patientType) === 1 &&
        formData.lastName.length === 0
      ) {
        setUiMessage('err', 'Please enter last name');
        return;
      }
      if (
        Number(formData.patientType) === 1 &&
        formData.firstName.length === 0
      ) {
        setUiMessage('err', 'Please enter first name');
        return;
      }

      if (Number(formData.patientType) === 1 && formData.gender.length === 0) {
        setUiMessage('err', 'Please select gender');
        return;
      }

      if (Number(formData.patientType) === 1 && formData.dob === null) {
        setUiMessage('err', 'Please select date of birth');
        return;
      }

      if (Number(formData.patientType) === 1 && formData.email.length === 0) {
        setUiMessage('err', 'Please enter email');
        return;
      }
      if (Number(formData.patientType) === 1 && formData.mobile.length === 0) {
        setUiMessage('err', 'Please enter mobile number');
        return;
      }

      if (checkedIds.length === 0) {
        setUiMessage('err', 'Please select atleast one intake form');
        return;
      }
      if (
        Number(formData.patientType) === 2 &&
        formData.patients.length === 0
      ) {
        setUiMessage('err', 'Please select atleast one patient');
        return;
      }

      let sendData = {
        patType: formData.patientType,
        intakeForm: checkedIds && checkedIds.join(','),
        intakeResource: formData.resource,
        intakeLocation: formData.location,
        patIds: formData.patients,
        loginUserId: user?.id,
      };
      if (formData.patientType === 1) {
        sendData = {
          ...sendData,

          intakeLastName: formData.lastName,
          intakeFirstName: formData.firstName,
          intakeEmail: formData.email,
          intakeGender: formData.gender,
          intakeDob: format(formData.dob, 'yyyy-MM-dd'),
          intakeMobile: formData.mobile,
        };
      }

      const response = await post(
        'api/patient/intake/saveIntakeForm',
        sendData,
      );
      if (response.status === 200) {
        if (response.data?.status === true) {
          setUiMessage('suc', response.data?.message);
        } else {
          setUiMessage('err', response.data?.message);
        }

        handleReload();
        close();
      }
    } catch (err) {
      setUiMessage('err', err?.message);
    }
  };

  const handleExistingPatient = useCallback((data) => {
    setFormData((prev) => ({ ...prev, patients: data }));
  }, []);

  return (
    <div className="modalBackground">
      <div className="intake-bill-note-con shadow">
        <div className="pmsPopupheader">
          <span className="pmsPopupheading">Intake</span>
          <Button variant="circle" onClick={close}>
            X
          </Button>
        </div>
        <div className="pmsPopupinnerBody intake-inr-bdy">
          <div className="pmsPopupinnerBodyrow p-chart-grid-alt">
            <span className="pmsPopuplabel med-value">
              Select Patient:<span className="required">*</span>
            </span>
            <span className="pmsPopupValue pmsPopup-selt-pat">
              <input
                type="radio"
                name="patType"
                checked={formData.patientType === 1 ? true : false}
                onChange={() => {
                  setFormData((prev) => ({ ...prev, patientType: 1 }));
                  setFormData((prev) => ({ ...prev, patients: '' }));
                }}
              />{' '}
              New
              <input
                className="clear-left"
                type="radio"
                name="patType"
                checked={formData.patientType === 2 ? true : false}
                onChange={() =>
                  setFormData((prev) => ({ ...prev, patientType: 2 }))
                }
              />{' '}
              Established
            </span>
          </div>
          <div className="width100 flex-sec">
            <div className="pmsPopupinnerBodyrow">
              <span className="pmsPopuplabel med-value">
                Location:<span className="required">*</span>
              </span>
              <span className="pmsPopupValue">
                <select
                  className="apnt-frm-select-wdth width100"
                  value={formData.location}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      location: e.target.value,
                    }))
                  }
                >
                  <option value=""></option>
                  {allData &&
                    allData?.allLocation?.map((loc) => {
                      return (
                        <option key={loc?.id} value={loc?.id}>
                          {loc?.location_code}
                        </option>
                      );
                    })}
                </select>
              </span>
            </div>
            <div className="pmsPopupinnerBodyrow">
              <span className="pmsPopuplabel med-value">
                Resource:<span className="required">*</span>
              </span>
              <span className="pmsPopupValue">
                <select
                  name="intakeResource"
                  className="patient-identity-info-gender-width width100"
                  value={formData.resource}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      resource: e.target.value,
                    }))
                  }
                >
                  <option value=""></option>
                  {allData &&
                    allData?.allResource?.map((res) => {
                      return (
                        <option key={res?.id} value={res?.id}>
                          {`${ucFirst(res?.first_name)}  ${res?.last_name}${
                            res?.degree ? ', ' + res?.degree : ''
                          }`}
                        </option>
                      );
                    })}
                </select>
              </span>
            </div>
          </div>

          {formData.patientType === 1 && (
            <>
              <div className="width100 flex-sec  p-chart-grid-alt">
                <div className="pmsPopupinnerBodyrow">
                  <span className="pmsPopuplabel med-value">
                    Last Name:<span className="required">*</span>
                  </span>
                  <span className="pmsPopupValue">
                    <input
                      type="text"
                      className="ticket-subjct-inpt"
                      placeholder="Write your last name"
                      value={formData.lastName}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          lastName: e.target.value,
                        }))
                      }
                    />
                  </span>
                </div>
                <div className="pmsPopupinnerBodyrow">
                  <span className="pmsPopuplabel med-value">
                    First Name:<span className="required">*</span>
                  </span>
                  <span className="pmsPopupValue">
                    <input
                      type="text"
                      name="intakeFirstName"
                      id="intakeFirstName"
                      className="ticket-subjct-inpt"
                      placeholder="Write your first name"
                      value={formData.firstName}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          firstName: e.target.value,
                        }))
                      }
                    />
                  </span>
                </div>
              </div>
              <div className="width100 flex-sec">
                <div className="pmsPopupinnerBodyrow">
                  <span className="pmsPopuplabel med-value">
                    Sex:<span className="required">*</span>
                  </span>
                  <span className="pmsPopupValue">
                    <select
                      name="intakeGender"
                      className="patient-identity-info-gender-width width100"
                      value={formData.gender}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          gender: e.target.value,
                        }))
                      }
                    >
                      <option value=""></option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="decline">Decline</option>
                      <option value="unknown">Unknown</option>
                      <option value="other">Other</option>
                    </select>
                  </span>
                </div>
                <div className="pmsPopupinnerBodyrow">
                  <span className="pmsPopuplabel med-value">
                    DOB:<span className="required">*</span>
                  </span>
                  <span className="pmsPopupValue">
                    <DatePickerCalander
                      selectedDate={formData.dob}
                      setSelectedDate={(date) =>
                        setFormData((prev) => ({ ...prev, dob: date }))
                      }
                      className="add-task-date-picker"
                      style={{
                        width: '75px',
                      }}
                      dateFormat={DEFAULT_DATE_FORMATE}
                      showYearDropdown
                      maxDate={new Date()}
                      minDate={new Date('1900-01-01')}
                    />
                  </span>
                </div>
              </div>
              <div className="width100 flex-sec  p-chart-grid-alt">
                <div className="pmsPopupinnerBodyrow">
                  <span className="pmsPopuplabel med-value">
                    Mobile#:<span className="required">*</span>
                  </span>
                  <span className="pmsPopupValue">
                    <input
                      type="text"
                      name="intakeMobile"
                      id="intakeMobile"
                      className="ticket-subjct-inpt"
                      placeholder="(000) 000-0000"
                      maxLength="14"
                      value={formData.mobile}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          mobile: e.target.value,
                        }))
                      }
                    />
                  </span>
                </div>
                <div className="pmsPopupinnerBodyrow">
                  <span className="pmsPopuplabel med-value">
                    Email:<span className="required">*</span>
                  </span>
                  <span className="pmsPopupValue">
                    <input
                      type="text"
                      name="intakeEmail"
                      id="intakeEmail"
                      className="ticket-subjct-inpt"
                      placeholder="Write your email"
                      value={formData.email}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          email: e.target.value,
                        }))
                      }
                    />
                  </span>
                </div>
              </div>
              <div className="width100 flex-sec  p-chart-grid-alt">
                <div className="pmsPopupinnerBodyrow">
                  <span className="pmsPopuplabel med-value">
                    Send Patient Portal (PP) Invite for Onboarding:
                  </span>
                  <span className="pmsPopupValue">
                    <input
                      type="checkbox"
                      name="intakePPInvite"
                      id="intakePPInvite"
                      className="clear-left10"
                      value={formData.onboard}
                      checked={formData.onboard === '0' ? false : true}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          onboard: e.target.checked ? '1' : '0',
                        }))
                      }
                    />
                  </span>
                </div>
              </div>
            </>
          )}

          {formData.patientType === 2 && (
            <div
              className="pmsPopupinnerBodyrow p-chart-grid-alt"
              style={{ position: 'relative', paddingLeft: '5px' }}
            >
              <span className="pmsPopuplabel med-value">Search Patient:</span>
              <span className="pmsPopupValue intake-srch-panel">
                <ComPatSearch
                  key={formData.patientType}
                  defaultPat={[]}
                  msgType={''}
                  bigSearchBox={true}
                  fieldName={''}
                  changeShow={false}
                  handlePatArr={handleExistingPatient}
                  returntype={'str'}
                  intakePatSrch={true}
                />
                {/* <input
                  placeholder="LN FN, Chart#, DOB MMDDYYYY or MM/DD/YYYY, Email, Phone, MRN"
                  className="type-input type-new-input left"
                  type="text"
                  name="patIntakeSearch"
                  id="patIntakeSearch"
                  clickbutton="intake-patient-search"
                  title="Type at least 1 character to search"
                  autocomplete="off"
                />

                <span
                  className="button new-button cursor-style-for-link"
                  id="intake-patient-search"
                  clickbutton="intake-patient-search"
                >
                  &nbsp;
                </span>
                <span
                  className="button new-cross-button cursor-style-for-link hide"
                  id="intake-patient-search-delete"
                  clickbutton="intake-patient-search"
                >
                  &nbsp;
                </span> */}
              </span>
            </div>
          )}
          <div className="pmsPopupinnerBodyrow">
            <span className="pmsPopuplabel med-value">
              Select Forms:<span className="required">*</span>
            </span>
            <span className="pmsPopupValueChkBox">
              {allData?.intakeFormList &&
                allData?.intakeFormList.map((form) => {
                  return (
                    <div key={form.formId}>
                      <div className="intake-pt-intk-frm-hdng">
                        <input
                          className=""
                          type="checkbox"
                          checked={parentChecked[form.formId] || false}
                          onChange={(e) =>
                            handleParentCheckboxChange(e, form.formId)
                          }
                        />
                        <span className="clear-left5">{form.formName}</span>
                      </div>
                      <div style={{ paddingLeft: '25px' }}>
                        {form.subCat.map((sub) => (
                          <span
                            className="intake-pt-intk-frm-sbhdng"
                            key={sub.intakecatId}
                          >
                            <input
                              className="left clear-right10"
                              type="checkbox"
                              checked={checkedIds.includes(sub.intakecatId)}
                              onChange={(e) =>
                                handleSubChildCheckboxChange(e, sub.intakecatId)
                              }
                            />
                            <span
                              className="left"
                              onClick={() =>
                                handleIntakeFormPreview(sub.intakefilePath)
                              }
                            >
                              {sub.intakecatName}
                            </span>
                            <br />
                          </span>
                        ))}
                      </div>
                    </div>
                  );
                })}
            </span>
          </div>
        </div>

        <div className="intake-add-popup-footer gap10">
          <Button variant="outline" onClick={close}>
            Close
          </Button>
          <Button variant="primary" onClick={() => handleSaveIntakeForm()}>
            Send
          </Button>
        </div>
      </div>
    </div>
  );
}

export default AddIntakeFormPopup;
